import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../Model/Common/common.service';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { NgbDatepickerModule, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SiteLockServiceService } from '../site-lock-service.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { SessionService } from '../Util/Session/session.service';

@Component({
  selector: 'app-site-lock-unlock',
  standalone: true,
  imports: [CommonModule, LoaderComponent, NgSelectModule, FormsModule, NgbTooltip, NgbDatepickerModule, DataTablesModule],
  templateUrl: './site-lock-unlock.component.html',
  styleUrl: './site-lock-unlock.component.scss'
})
export class SiteLockUnlockComponent {

  isDisabled: boolean = false;
  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Branchs = [] as any;
  Clients = [] as any;
  TableData = [] as any;

  Filter = {
    BranchId: null,
    ClientId: null,
    MonthName: null as any,
    SiteFor: "1"
  }

  constructor(
    public common: CommonService,
    private comboload: ComboService,
    private toast: ToastService,
    private siteLock: SiteLockServiceService,
    private dateFormat: CustomDateParserFormatter,
    private modalService: NgbModal,
    private session: SessionService
  ) {
    // this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.ComboLoad('Branch');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      // this.Filter.SiteId = null;
      // this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      // this.Filter.SiteId = null;
      this.Clients = [];
      // this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': 0,
      'EmpType': 'front',
      'EmpCode': ''
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onNavigate(event: any) {
    this.Filter.MonthName = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  GetSites() {
    if (this.Filter.BranchId == null || this.Filter.BranchId == "") {
      this.toast.show({ message: 'Kindly select Branch', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.siteLock.GetAttendanceLockUnlockSite({
      SelectType: Number(this.Filter.SiteFor),
      SiteId: 0,
      BranchId: this.Filter.BranchId,
      ClientId: this.Filter.ClientId,
      MonthName: this.dateFormat.fullmonth[this.Filter.MonthName.month - 1],
      YearName: this.Filter.MonthName.year,
    }).subscribe({
      next: (response) => {
        if (response.ErrorCode == "" && response.Sites.length == 0){
          this.toast.show({message: 'No Data Found', type: toastTypeEnum.warning});
          return;
        }
        else if (response.ErrorCode == "") {
          this.TableData = response.Sites;
          this.TableData = response.Sites.map((e: any) => ({ ...e, checked: false }));
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } else {
          this.clear();
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.ErrorMessage;
          modalRef.result.then((result: any) => {
            if (result) {
            }
          });
        }

        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CheckAll(event: any) {
    this.TableData.forEach((e: any) => {
      e.checked = event.target.checked;
    });
  }

  clear() {
    this.TableData = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  Save() {
    if(this.TableData.filter((e: any) => e.checked).length < 1){
      this.toast.show({ message: 'Kindly select any data to continue', type: toastTypeEnum.warning });
      return;
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to ' + [this.Filter.SiteFor == "1" ? 'Lock' : "Unlock"] + ' these Sites ?';
    modalRef.result.then(async (result: any) => {
      if (result) {
        this.LockUnlockSites()
      }
    })
  }

  LockUnlockSites(){
    const FilteredData = this.TableData.filter((e: any) => e.checked);
    this.isDisabled = true;
    this.siteLock.LockUnlockSites({
      SelectType: this.Filter.SiteFor == "1" ? 'Lock': 'Reset',
      MonthName: this.dateFormat.fullmonth[this.Filter.MonthName.month - 1],
	    YearName: this.Filter.MonthName.year,
	    SiteIds: FilteredData.map((e: any) => e.SiteMasterID).join(','),
	    By: this.session.GetUserDetails().UserId,
    }).subscribe({
      next: (response) => {
        if(response.Table){
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Site Updated Successfully';
          modalRef.result.then((result: any) => {
            if (result) {
              this.clear();
            }
          });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
